import {
	IconCheckOutline18 as Check,
	IconMsgCheckOutline18 as MsgCheck,
	IconMsgDottedOutline18 as MsgDotted,
} from "nucleo-ui-outline-18"

import type { ReplyStateFilter } from "@productlane/zero/queries"
import { cn } from "@productlane/lib/src/browser"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { useThreadsFilterState } from "../threads-filter-state"

export const REPLY_STATES: ReplyStateFilter[] = ["NEEDS_RESPONSE", "REPLIED"]

export const ReplyStateNaming: Record<ReplyStateFilter, string> = {
	NEEDS_RESPONSE: "Needs response",
	REPLIED: "Replied",
}

export const ReplyStateIcons: Record<ReplyStateFilter, typeof MsgDotted> = {
	NEEDS_RESPONSE: MsgDotted,
	REPLIED: MsgCheck,
}

export function ReplyStateFilterItems({ onSelect }: SharedFilterItemsProps) {
	const { replyStates, addReplyState, removeReplyState } =
		useThreadsFilterState()

	return (
		<>
			{REPLY_STATES.map((replyState) => {
				const isSelected = replyStates.includes(replyState)
				return (
					<CommandItem
						onSelect={() => {
							if (isSelected) {
								removeReplyState(replyState)
							} else {
								addReplyState(replyState)
							}
							onSelect()
						}}
						key={replyState}
						Icon={ReplyStateIcons[replyState]}
					>
						<div className="flex w-full items-center gap-2">
							<span className="flex-1 truncate">
								{ReplyStateNaming[replyState]}
							</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
